<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "StorageZoneForm",
  components: {
    AdminForm
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        warehouse_id: null
      },
      isBusy: false
    };
  },
  computed: {
    options: function() {
      return {
        warehouse_id_options: this.$store.getters[
          "warehouse/getAll"
        ].selectOptions("id", ["internal_code", " - ", "name"])
      };
    }
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true
        })
        .then(() => {
          let item = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](id)
          );
          this.form = {
            ...item,
            warehouse_id: item.warehouse ? item.warehouse.id : null
          };
          this.isBusy = false;
        });
    }

    this.$store.dispatch("warehouse/getAllForSelect");
  }
};
</script>


// WEBPACK FOOTER //
// src/components/StorageZone/StorageZoneForm.vue